import type { FilterOption } from '../../../types/FilterOption';

import { isDefined } from '../../filter-util';

/**
 * Transforms an array of items into filter options for the filter bar.
 * Filters out undefined items and maps each remaining item to a label/value pair.
 *
 * @param items - The source array, which may contain undefined entries.
 * @param label - Extractor function that returns the display label for an item.
 * @param value - Extractor function that returns the option value for an item.
 */
const toFilterOptions = <T>({
    items,
    label,
    value,
}: {
    items: Array<T | null | undefined> | null | undefined;
    label: (item: T) => string;
    value: (item: T) => string;
}): Array<FilterOption> =>
    items?.filter(isDefined).map((item) => ({
        label: label(item),
        value: value(item),
    })) ?? [];

export { toFilterOptions };
